import RadioButtons from 'components/widgets/RadioButtons.vue';
import ToggleCheckbox from 'components/widgets/ToggleCheckbox.vue';
import Vue from 'vue';
import objectHash from 'object-hash';
export default Vue.extend({
    components: { RadioButtons, ToggleCheckbox },
    props: {
        /** `options` is an array of "columns". Inside each element (column),
         * there is another array, of "cells". These cells are rendered top-down
         * in the same order as the array of cells. Inside each cell are some
         * metadata for that cell, like "title", and the "type" of cell it is.
         * In the typescript definition above, the cell is called "MenuEntry".
         * The cell also contains a property called "options" which are the
         * selectable items the user sees and can choose from for selection. */
        options: { type: Array, required: true, default: () => [] },
        displayCenter: { type: Boolean, default: true },
        styleObject: { type: Object, default: () => ({}) },
        visible: { type: Boolean, default: false },
        bound: { type: HTMLElement, default: null, required: false },
        maxLabelLength: { type: Number, required: false, default: 25 }
    },
    data() {
        return {
            maxHeight: null,
        };
    },
    watch: {
        visible(val) { if (val)
            this.setMaxHeight(); }
    },
    mounted() {
        document.addEventListener('click', this.onDocumentClick.bind(this));
    },
    beforeDestroy: function () {
        // Cleanup click handler for custom display dropdown (when clicking outside element)
        document.removeEventListener('click', this.onDocumentClick);
    },
    methods: {
        objectHash(value) {
            return objectHash(value);
        },
        setMaxHeight() {
            this.$nextTick(() => {
                if (this.visible && this.bound && this.$el) {
                    this.maxHeight = this.bound.clientHeight * 0.6;
                }
            });
        },
        /**
         * This method is a simple passthrough to emitting a value on menu option change.
         * The expected return value is an array of two values, [ColumnLabel, Field]
         * i.e ['Impact On', 'Sentiment'] */
        changeOption(row, value, dismiss) {
            if (![].concat(row.selected).includes(value)) {
                this.$emit('changeOption', [row.title, value]);
                if (dismiss)
                    this.$emit('hide');
            }
        },
        changeCheckboxOption(row, value, dissmiss) {
            if (row.selected && row.selected.includes(value)) {
                this.$emit('changeOption', [row.title, row.selected.filter(v => v !== value)]);
            }
            else {
                this.$emit('changeOption', [row.title, row.selected ? [...row.selected, value] : [value]]);
            }
        },
        // Hide/reset popover when the document background is clicked.
        onDocumentClick(e) {
            // Don't close if the element clicked is a date picker.
            const isDatePicker = e.target.closest('.pika-single');
            if (this.visible && !isDatePicker)
                this.$emit('hide');
        },
        ensureOptionsLabelled(menu_options) {
            /** Both objects and plain strings are supported for this prop. If it's not
             * the "object" kind, then make a conforming object structure so that
             * the template only ever needs to know about the object kind.
             *
             * Since the template only knows about the object kind, what
             * do we emit if user selects an option? The answer is that
             * we always emit the *value* (check with the emit events). It is up to
             * the caller how * to map that back to their option. */
            return menu_options.map(option => option.label ? option : { label: option, value: option });
        },
        moveToolTip(el) {
            const target = el.target;
            const column = target?.parentElement?.parentElement;
            const tooltip = target?.querySelector('.tooltip');
            if (target && column && tooltip) {
                tooltip.style.transform = `translate3d(${target.offsetLeft}px, ${
                // calculate height to place tooltip relative to .dropdown-menu
                // Adjustment of 2px helps with removing the tooltip visibility
                // on menu option mouseout (so the tooltip doesn't gain hover focus)
                target.offsetTop + target.offsetHeight - column.scrollTop + 2}px, 0)`;
            }
        },
    }
});
